import EventEmitter from 'eventemitter3'

export const chatEvent = new EventEmitter()

export function onNewChatMessage(messagePayload) {
    chatEvent.emit('NEW-MESSAGE', messagePayload)
}

export function removeChatListener() {
    chatEvent.removeListener('NEW-MESSAGE')
}

export function onSenderRoomMessageChange() {
    chatEvent.emit('SENDER-ROOM-MESSAGE-CHANGE')
}

export function removeSenderRoomMessageChange() {
    chatEvent.removeListener('SENDER-ROOM-MESSAGE-CHANGE')
}

export function onReceiverRoomMessageChange(payload) {
    chatEvent.emit('RECEIVER-ROOM-MESSAGE-CHANGE', payload)
}

export function removeReceiverRoomMessageChangeListener() {
    chatEvent.removeListener('RECEIVER-ROOM-MESSAGE-CHANGE')
}

export function setRoomMessage(roomId) {
    chatEvent.emit('NOTIFICATION-CHANGE', roomId)
}

export function removeRoomMessage() {
    chatEvent.removeListener('NOTIFICATION-CHANGE')
}
